/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// close popup
function closeIt(id) {
  // console.log('id', id);
  document.querySelector(`#${id}`).classList.add("hide");
}

// Mega menu custom hover function
function megaMenuHover(e) {
  console.log("Mega menu hover", e.dataset.menu);
  let level_2_menu_all = document.querySelectorAll(".custom-mega-menu-2");
  let hovered_level_2_menu = document.querySelector(
    '.custom-mega-menu-2[data-menu="' + e.dataset.menu + '"]'
  );

  let level_3_menu_all = document.querySelectorAll(
    ".mega-menu__inner.col-3-custom"
  );
  let level_3_menu = document.querySelector(
    '.mega-menu__inner.col-3-custom[data-menu="' + e.dataset.menu + '"]'
  );

  level_2_menu_all.forEach.call(level_2_menu_all, function (e) {
    e.classList.remove("active");
  }); // remove all 'active' class
  hovered_level_2_menu.classList.add("active");

  level_3_menu_all.forEach.call(level_3_menu_all, function (e) {
    e.classList.remove("active");
  }); // remove all 'active' class
  // set 'active' class to the menu
  if (level_3_menu) {
    // IF the menu has sub menus
    level_3_menu.classList.add("active"); // add 'active' class
  } else {
    // if level 2 menu doesn't have sub menu, don't remove 'active' class
  }
}

// Tab function (on product page)
function openTab(e) {
  let activeTargetMenu = document.querySelector(
    '.collections_tab li button[data-bid="' + e.dataset.bid + '"]'
  );
  let activeTargetCon = document.querySelector(
    '.scroller[data-bid="' + e.dataset.bid + '"]'
  );
  let tabMenu_all = document.querySelectorAll(".collections_tab li button");
  let tabCon_all = document.querySelectorAll(
    ".collection-recommendations .scroller"
  );

  tabMenu_all.forEach.call(tabMenu_all, function (e) {
    e.classList.remove("active");
  }); // remove all 'active' class of tab menus
  tabCon_all.forEach.call(tabCon_all, function (e) {
    e.classList.remove("active");
  }); // remove all 'active' class of tab content

  activeTargetMenu.classList.add("active"); // set 'active' class to tab menu
  activeTargetCon.classList.add("active"); // set 'active' class to tab content
}

/* Search question & answer on FAQs page
 * function #1: setFaqsSearchData()
 * function #2: searchFAQs()
 * function #3: searchInputRemove()
 */

var faqSearchArr = [];
function setFaqsSearchData() {
  let faqItems = document.querySelectorAll(".faq__item");
  // set Search data array
  faqItems.forEach.call(faqItems, function (e) {
    faqSearchArr.push(e.dataset.q);
  });
}
setFaqsSearchData(); // when load, it should be run

function searchFAQs(e) {
  let searchWord = e.value.toLowerCase();
  let faqItems = document.querySelectorAll(".faq__item");
  let searchBtn = document.querySelector(".faq_input_wrap .search-bar__submit");
  // console.log('searchWord:', searchWord)
  // hide all products
  faqItems.forEach.call(faqItems, function (e) {
    e.classList.add("hide");
  });
  // display searched result
  faqSearchArr.forEach((element) => {
    if (element.includes(searchWord)) {
      let searched = document.querySelectorAll(
        '.faq__item[data-q="' + element + '"]'
      );
      searched.forEach.call(searched, function (e) {
        e.classList.remove("hide");
      });
    }
  });
  if (searchWord != "") {
    searchBtn.classList.add("cross");
  } else {
    searchBtn.classList.remove("cross");
  }
}

function searchInputRemove(e) {
  let faqItems = document.querySelectorAll(".faq__item");
  let searchInput = document.querySelector("#faq_search");
  // show all products
  faqItems.forEach.call(faqItems, function (e) {
    e.classList.remove("hide");
  });

  searchInput.value = ""; // reset search word

  // Button reset
  e.classList.remove("cross");
}

// $(function () {
//   $(".stock-popup").on("click", function () {
//     $(".stock-popup").remove();
//   });
// });
(function () {
  function hideNotForSaleButtons() {
    document.querySelectorAll('.boost-sd__product-item').forEach(function (item) {
      try {
        const productData = JSON.parse(item.getAttribute('data-product'));

        if (
          productData.tags &&
          productData.tags.includes('Not For Sale')
        ) {
          const button = item.querySelector(
            '.boost-sd__button--select-option'
          );

          if (button) {
            button.style.display = 'none';
          }
        }
      } catch (error) {
        // Ignore invalid product data
      }
    });
  }

  // Initial check
  hideNotForSaleButtons();

  // Re-check when Boost dynamically loads/updates products
  const observer = new MutationObserver(function () {
    hideNotForSaleButtons();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();